/* Reborn Naturals Shopify theme: cart drawer, cart page, product page and shop filter.
   The cart is Shopify's own cart (AJAX API: /cart.js, /cart/add.js, /cart/change.js). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const P = window.RN_PRODUCTS || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inr = n => '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  const ic = n => `<svg class="ic"><use href="#i-${n}"/></svg>`;
  const esc = s => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const routes = window.RN_ROUTES || { cart: '/cart', all: '/collections/all', checkout: '/checkout' };

  /* ---------- store ---------- */
  let raw = window.RN_CART || { items: [], item_count: 0, total_price: 0 };
  let busy = false;
  const lines = () => raw.items.map(i => {
    const p = P[String(i.variant_id)] || {};
    return {
      key: i.key, id: String(i.variant_id), qty: i.quantity,
      price: i.final_price / 100, line: i.final_line_price / 100,
      compare: p.compare || 0,
      title: p.short || i.product_title, sub: p.size || p.sub || (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : ''),
      img: p.img || (i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : ''),
      url: i.url || ('/products/' + i.handle)
    };
  });
  const totals = ls => ({
    count: raw.item_count, sub: raw.total_price / 100,
    save: ls.reduce((s, l) => s + (l.compare > l.price ? (l.compare - l.price) * l.qty : 0), 0)
  });
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then(r => r.json().then(j => { if (!r.ok) throw j; return j; }));
  const refresh = () => fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(j => { raw = j; render(); return j; });
  const add = (id, qty = 1) => post(routes.cart + '/add.js', { items: [{ id: Number(id), quantity: qty }] }).then(refresh)
    .catch(err => { toast(esc(err && (err.description || err.message) || 'Could not add to cart')); throw err; });
  const setQty = (key, qty) => { if (busy) return; busy = true; post(routes.cart + '/change.js', { id: key, quantity: Math.max(0, qty) }).then(j => { raw = j; render(); }).catch(() => refresh()).finally(() => { busy = false; }); };

  /* ---------- shared bits ---------- */
  const toastEl = $('[data-toast]');
  let toastT;
  const toast = msg => { if (!toastEl) return; toastEl.innerHTML = ic('check') + msg; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2400); };

  const qtyCtrl = l => `<div class="qty qty--sm"><button type="button" aria-label="Decrease quantity" data-line-dir="-1" data-line="${l.key}">${ic('minus')}</button><span aria-live="polite">${l.qty}</span><button type="button" aria-label="Increase quantity" data-line-dir="1" data-line="${l.key}">${ic('plus')}</button></div>`;
  const lineHtml = l => `<div class="cline" data-line-row="${l.key}">
      <a class="cline__img" href="${l.url}"><img src="${l.img}" alt="" width="84" height="84" loading="lazy"></a>
      <div class="cline__info">
        <a class="cline__title" href="${l.url}">${esc(l.title)}</a>
        ${l.sub ? `<span class="cline__sub">${esc(l.sub)}</span>` : ''}
        <div class="cline__price"><b>${inr(l.price)}</b>${l.compare > l.price ? `<s>${inr(l.compare)}</s>` : ''}</div>
        ${qtyCtrl(l)}
      </div>
      <div class="cline__end">
        <b class="cline__total">${inr(l.line)}</b>
        <button class="cline__rm" type="button" data-line-rm="${l.key}" aria-label="Remove ${esc(l.title)}">${ic('trash')}</button>
      </div>
    </div>`;
  const upsellIds = () => {
    const inCart = new Set(raw.items.map(i => String(i.variant_id)));
    return Object.keys(P).sort((a, b) => P[a].order - P[b].order).filter(id => P[id].available && !inCart.has(id));
  };
  const price = p => `${inr(p.price)}${p.compare > p.price ? ` <s>${inr(p.compare)}</s>` : ''}`;
  const miniCard = id => { const p = P[id]; return `<div class="mini">
      <a class="mini__img" href="/products/${p.handle}"><img src="${p.img}" alt="" width="64" height="64" loading="lazy"></a>
      <div class="mini__txt"><a href="/products/${p.handle}">${esc(p.short)}</a><span>${price(p)}</span></div>
      <button class="icon-btn icon-btn--line mini__add" type="button" data-add="${id}" aria-label="Add ${esc(p.short)} to cart">${ic('plus')}</button>
    </div>`; };

  /* ---------- cart drawer ---------- */
  const cd = $('[data-cdrawer]');
  let lastFocus;
  const onCartPage = () => location.pathname.replace(/\/$/, '') === routes.cart;
  const openCart = () => {
    if (!cd) { location.href = routes.cart; return; }
    lastFocus = document.activeElement; cd.hidden = false; document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => cd.classList.add('is-open'));
    $('.cdrawer__panel', cd).focus({ preventScroll: true });
  };
  const closeCart = () => {
    if (!cd || cd.hidden) return;
    cd.classList.remove('is-open'); document.body.style.overflow = '';
    setTimeout(() => { cd.hidden = true; }, reduce ? 0 : 320);
    if (lastFocus) lastFocus.focus();
  };
  if (cd) {
    $$('[data-cdrawer-close]', cd).forEach(b => b.addEventListener('click', closeCart));
    cd.addEventListener('click', e => { if (e.target === cd) closeCart(); });
    addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  }
  $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { if (onCartPage()) return; e.preventDefault(); openCart(); }));

  function renderDrawer(ls, t) {
    if (!cd) return;
    const items = $('[data-cart-items]', cd), foot = $('[data-cart-foot]', cd);
    $('[data-cart-count-text]', cd).textContent = t.count ? `(${t.count})` : '';
    if (!ls.length) {
      items.innerHTML = `<div class="cempty"><span class="cempty__ic">${ic('bag')}</span><p class="cempty__title">Your cart is empty</p><a class="btn btn--dark" href="${routes.all}" data-cdrawer-close>Shop all ${ic('arrow')}</a></div>
        <div class="cupsell"><p class="cupsell__title">Best sellers</p>${upsellIds().slice(0, 3).map(miniCard).join('')}</div>`;
      foot.innerHTML = '';
      $$('[data-cdrawer-close]', items).forEach(b => b.addEventListener('click', closeCart));
      return;
    }
    const ups = upsellIds().slice(0, 2);
    items.innerHTML = ls.map(lineHtml).join('') + (ups.length ? `<div class="cupsell"><p class="cupsell__title">You may also like</p>${ups.map(miniCard).join('')}</div>` : '');
    foot.innerHTML = `${t.save ? `<div class="crow crow--save"><span>${ic('tag')}You save</span><b>${inr(t.save)}</b></div>` : ''}
      <div class="crow crow--sub"><span>Subtotal</span><b>${inr(t.sub)}</b></div>
      <p class="cnote">Taxes included. Shipping calculated at checkout.</p>
      <a class="btn btn--dark btn--lg btn--block" href="${routes.checkout}">${ic('lock')}Checkout</a>
      <a class="clink" href="${routes.cart}">View cart</a>`;
  }

  /* ---------- cart page ---------- */
  function renderPage(ls, t) {
    const wrap = $('[data-cartpage]');
    if (!wrap) return;
    const items = $('[data-cart-items-page]'), sum = $('[data-cart-summary]');
    wrap.classList.toggle('is-empty', !ls.length);
    if (!ls.length) {
      items.innerHTML = `<div class="cempty cempty--page"><span class="cempty__ic">${ic('bag')}</span><p class="cempty__title">Your cart is empty</p><a class="btn btn--dark btn--lg" href="${routes.all}">Shop all ${ic('arrow')}</a></div>`;
      sum.innerHTML = '';
    } else {
      items.innerHTML = ls.map(lineHtml).join('');
      sum.innerHTML = `<h2 class="summary__title">Order summary</h2>
        <div class="crow"><span>Subtotal (${t.count} ${t.count === 1 ? 'item' : 'items'})</span><b>${inr(t.sub + t.save)}</b></div>
        ${t.save ? `<div class="crow crow--save"><span>${ic('tag')}Savings</span><b>- ${inr(t.save)}</b></div>` : ''}
        <div class="crow"><span>Shipping</span><span class="muted">Calculated at checkout</span></div>
        <div class="crow crow--total"><span>Total</span><b>${inr(t.sub)}</b></div>
        <p class="cnote">Taxes included.</p>
        <a class="btn btn--dark btn--lg btn--block" href="${routes.checkout}">${ic('lock')}Checkout</a>
        <ul class="summary__perks"><li>${ic('truck')}Free shipping on every Kaadha combo</li><li>${ic('shield')}Haircare Combo comes with a Guarantee Card</li><li>${ic('lock')}Secure payment</li></ul>`;
    }
    const up = $('[data-cart-upsell]');
    if (up) {
      const ids = upsellIds().slice(0, 4);
      up.closest('section').hidden = !ids.length;
      up.innerHTML = ids.map(id => { const p = P[id]; return `<article class="pcard"><a class="pcard__media" href="/products/${p.handle}"><img class="pcard__img" src="${p.img}" alt="${esc(p.title)}" width="600" height="600" loading="lazy"></a><div class="pcard__body"><h3 class="pcard__title"><a href="/products/${p.handle}">${esc(p.short)}</a></h3><p class="pcard__desc">${esc(p.sub)}</p><div class="price"><span class="price__now">${inr(p.price)}</span>${p.compare > p.price ? `<s class="price__was">${inr(p.compare)}</s>` : ''}</div><button class="btn btn--dark btn--block btn--sm" type="button" data-add="${id}">${ic('bag')}Add to cart</button></div></article>`; }).join('');
    }
  }
  const note = $('[data-order-note]');
  if (note) {
    note.value = raw.note || '';
    let nt; note.addEventListener('input', () => { clearTimeout(nt); nt = setTimeout(() => post(routes.cart + '/update.js', { note: note.value }), 500); });
  }

  /* ---------- header count ---------- */
  let lastCount = null;
  function renderCount(t) {
    $$('[data-cart-count]').forEach(b => {
      b.hidden = !t.count; b.textContent = t.count;
      if (lastCount !== null && t.count > lastCount && !reduce) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    });
    $$('[data-cart-open]').forEach(a => a.setAttribute('aria-label', t.count ? `Cart, ${t.count} ${t.count === 1 ? 'item' : 'items'}` : 'Cart'));
    lastCount = t.count;
  }

  function render() {
    const ls = lines(), t = totals(ls);
    renderCount(t); renderDrawer(ls, t); renderPage(ls, t);
  }

  /* ---------- delegated actions ---------- */
  document.addEventListener('click', e => {
    const addBtn = e.target.closest('[data-add]');
    if (addBtn) {
      e.preventDefault();
      const id = addBtn.dataset.add;
      addBtn.classList.add('is-loading');
      add(id, 1).then(() => {
        if (!reduce) { addBtn.classList.add('is-added'); setTimeout(() => addBtn.classList.remove('is-added'), 1200); }
        if (onCartPage()) toast(`${esc((P[id] && P[id].short) || 'Item')} added`); else openCart();
      }).catch(() => {}).finally(() => addBtn.classList.remove('is-loading'));
      return;
    }
    const dir = e.target.closest('[data-line-dir]');
    if (dir) { const l = lines().find(x => x.key === dir.dataset.line); if (l) setQty(l.key, l.qty + Number(dir.dataset.lineDir)); return; }
    const rm = e.target.closest('[data-line-rm]');
    if (rm) { const row = rm.closest('.cline'); const key = rm.dataset.lineRm; if (row && !reduce) { row.classList.add('is-leaving'); setTimeout(() => setQty(key, 0), 260); } else setQty(key, 0); }
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const id = pdp.dataset.id;
    const track = $('[data-gallery-track]', pdp);
    const thumbs = $$('[data-thumb]', pdp);
    const counter = $('[data-gallery-i]', pdp);
    const slides = track ? $$('.pdp__slide', track) : [];
    let cur = 0;
    const setActive = i => {
      cur = i; if (counter) counter.textContent = i + 1;
      thumbs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.toggleAttribute('aria-current', k === i); });
      const th = thumbs[i]; if (th) th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    };
    const go = i => { if (!slides.length) return; i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); };
    if (track) {
      track.addEventListener('scroll', () => requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setActive(i); }), { passive: true });
      track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    }
    thumbs.forEach(t => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    $$('[data-gallery-dir]', pdp).forEach(b => b.addEventListener('click', () => go(cur + Number(b.dataset.galleryDir))));

    const qi = $('[data-qty-input]', pdp);
    const clamp = v => Math.max(1, Math.min(10, parseInt(v, 10) || 1));
    $$('[data-qty-dir]', pdp).forEach(b => b.addEventListener('click', () => { qi.value = clamp(Number(qi.value) + Number(b.dataset.qtyDir)); }));
    if (qi) qi.addEventListener('change', () => { qi.value = clamp(qi.value); });

    const addBtn = $('[data-add-pdp]', pdp);
    if (addBtn) addBtn.addEventListener('click', () => {
      addBtn.classList.add('is-loading');
      add(addBtn.dataset.addPdp || id, clamp(qi.value)).then(() => {
        addBtn.classList.add('is-added');
        addBtn.querySelector('span').textContent = 'Added';
        setTimeout(() => { addBtn.classList.remove('is-added'); addBtn.querySelector('span').textContent = 'Add to cart'; }, 1600);
        openCart();
      }).catch(() => {}).finally(() => addBtn.classList.remove('is-loading'));
    });
    const now = $('[data-buy-now]', pdp);
    if (now) now.addEventListener('click', e => { e.preventDefault(); location.href = `/cart/${now.dataset.buyNow || id}:${clamp(qi.value)}`; });

    // sticky buy bar once the main buy box scrolls away
    const bar = $('[data-sticky-pdp]'), box = $('[data-buybox]', pdp), footer = $('.footer');
    if (bar && box) {
      let past = false, atEnd = false;
      const set = () => { const on = past && !atEnd; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on); bar.querySelector('a').tabIndex = on ? 0 : -1; };
      new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; set(); }).observe(box);
      if (footer) new IntersectionObserver(([e]) => { atEnd = e.isIntersecting; set(); }).observe(footer);
    }
  }

  /* ---------- shop filter ---------- */
  const filter = $('[data-filter]');
  if (filter) {
    const cards = $$('[data-plp] .pcard');
    filter.addEventListener('click', e => {
      const b = e.target.closest('[data-f]'); if (!b) return;
      $$('[data-f]', filter).forEach(x => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      const f = b.dataset.f;
      cards.forEach(c => { const show = f === 'all' || (c.dataset.cat || '').split(' ').includes(f); c.hidden = !show; if (show && !reduce) { c.classList.remove('in'); requestAnimationFrame(() => requestAnimationFrame(() => c.classList.add('in'))); } });
    });
  }

  render();
})();
